<template>
  <div class="navsed">
    <h1 style="padding:10px 10%;text-align:center">公司简介</h1>
    <h2 style="padding:10px 10%;">
      重庆西南信息有限公司为国家科技部西南信息中心转制企业，2004年4月正式成立，主要业务有：软件开发；展馆展厅设计与施工；多媒体互动展示；
      平面期刊、学术期刊系列、核心期刊出版发行；数字化加工；综合数据库、专业网站的网站群，为用户开展数据服务、咨询服务及专业性的增值服务；
      生产力促进中心和国家级科技查新中心；房地产开发及物业管理；印刷。公司与时俱进，按增强核心竞争力、创造新业务增长点的发展思路，在不断提升原有业务的同时，
      紧跟市场需求和技术发展，开拓新的服务领域，使信息业务在经营规模、技术层次、产品和服务品质方面，不断上台阶，在全国信息行业中，拥有较强的信息资源优势、
      信息技术和产品开发优势、信息服务优势，成为我国信息处理技术研发、信息加工、信息产品生产和服务的重要基地。
    </h2>
    <search />
    <div id="navsed">
      <router-view />
    </div>
  </div>
</template>

<script>
import search from "@/components/search";
export default {
  data() {
    return {
      active: 1,
      mouseoverFlag: false // 热榜未点击前，mouserover无效
    };
  },
  mounted() {
    this.$root.Hub.$on("changeState2", x => {
      console.log("x", x);
      this.mouseoverFlag = x;
    });
  },
  created() {
    this.active = this.active;
  },
  components: {
    search
  },
  methods: {
    selectItem(index) {
      this.active = index;
    },
    translateState(index) {
      this.active = index;
      console.log("热榜 被点击了");
      let stateof = true;
      this.$root.Hub.$emit("changeState", stateof);
      this.mouseoverFlag = true;
    },
    translateState2() {
      console.log("mouseover");
      let stateof = true;
      this.$root.Hub.$emit("changeState", stateof);
    }
  }
};
</script>

<style scoped>
#navsed {
  /* width: 100%; */
  /* border: 1px solid forestgreen; */
  /* background-color: #f7f7f7; */
}
.head_navsed {
  width: 100%;
  overflow: hidden;
  text-align: center;
  height: 90px;

  /* border: 1px solid red; */
}
a {
  text-decoration: none;
  margin-right: 60px;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: normal;
  color: rgba(74, 73, 73, 1);
  line-height: 50px;
  height: 50px;
  /* font-weight: bold; */
  color: #2c3e50;
}
.active {
  /* border-bottom: 2px solid rgba(0,132,255,1); */
  color: #42b983;
}
/* .el-menu-demo {
  background-color: #f7f7f7;
  border-bottom: none;
  margin-left: 29%;
  height: 90px;
  line-height: 90px;
} */
.el-menu-item {
  border-bottom: none;
  text-decoration: none;
  margin-right: 30px;
  font-size: 21px;
  margin-top: 15px;
  font-family: Microsoft YaHei;
  font-weight: normal;
  color: rgba(74, 73, 73, 1);
  line-height: 50px;
  height: 50px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  color: #42b983;
  border: none;
  background: #f7f7f7;
}
</style>
